// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"git-repository"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M20 15H8C5.9602 15 4.27732 16.5269 4.03125 18.5C4.01082 18.3362 4 18.1693 4 18V6C4 3.79086 5.79086 2 8 2H20V15Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M9 15H13V19L11 18L9 19V15Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M9 15H13V19L11 18L9 19V15Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20 15V2H7.5C5.567 2 4 3.567 4 5.5V18.5M20 15V22H7.5C5.567 22 4 20.433 4 18.5M20 15H7.5C5.567 15 4 16.567 4 18.5M9.00391 6.00391H9V6H9.00391V6.00391ZM9.00391 9.00391H9V9H9.00391V9.00391Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-git-repository')
export default class GitRepositoryIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'git-repository',
    }
  }
}
